export const getColorFromCoefficient = (coefficient: number): string => {
    if (coefficient < 2) {
        return '#33B4FF';
    }

    if (coefficient < 10) {
        return '#8B3CED';
    }

    return '#C018B3';
};
